
























import YouWouldLike from '@/model/youWouldLike';
import {
  Vue,
  Prop,
  Component
} from 'vue-property-decorator';
@Component({
  components: {
    inButton: () => import(/* webpackChunkName: "product" */ '@/components/base/pc/InsButton.vue'),
    inPrices: () => import(/* webpackChunkName: "product" */ '@/components/base/pc/InsPrices.vue')
  }
})
export default class InsProductWindow extends Vue {
  private Enter: boolean = false;
  private newArray = [];
  @Prop() private item!: YouWouldLike;
  @Prop() private imgStyla!: string;
  @Prop() private styla!: string;
  buttonSubmit(item) {
    this.$router.push({
      path: '/product/detail',
      name: 'ProductsDetail',
      params: {
        id: item.Sku
      }
    });
  }
  addToFavorite(p) {
    if (p.IsFavorite) {
      this.$Api.member.removeFavorite(p.Sku).then((result) => {
        p.IsFavorite = false;
        this.$message({
          message: this.$t('MyFavorite.RemoveSuccess') as string
        });
      });
    } else {
      this.$Api.member.addFavorite(p.Sku).then((result) => {
        if (result.Succeeded) {
          p.IsFavorite = true;
          this.$message({
            message: this.$t('MyFavorite.AddSuccess') as string,
            type: 'success',
            customClass: 'messageboxNoraml'
          });
        } else {
          this.$router.push('/Account/login');
        }
      });
    }
  }
  addCart(val) {
    console.log(val.Sku);
    this.$Api.product.GetProduct(val.Sku).then((result) => {
      var a = result.PanelDetail.AttrList[0].length;
      var b = result.PanelDetail.AttrList[1].length;
      var c = result.PanelDetail.AttrList[2].length;
      var d = result.PanelDetail.AttrList[3].length;
      var e = result.PanelDetail.AttrList[4].length;
      var f = result.PanelDetail.AttrList[5].length;
      if (a || b || c || d || e || f) {
        this.$router.push('/product/detail/' + result.PanelDetail.Sku);
      } else {
        this.$Api.shoppingCart.addItem(val.Sku, 1, '1', '1', '1')
          .then(
            (result) => {
              this.$message({
                message: result.Message.Message as string,
                type: 'success',
                customClass: 'messageboxNoraml'
              });
            }).then(() => {
            this.$store.dispatch('setShopCart', this.$Api.shoppingCart.getShoppingCart());
          }).catch();
      }
    });
  }
  ToUrl(val) {
    this.$router.push('/product/detail/' + val.Sku);
  }
  loadError(e) {
    e.target.src = '/static/Image/proddef.jpg';
  }
}
